/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { POIDto } from './pOIDto';
import { BoundaryDto } from './boundaryDto';
import { GeoCoordinateDto } from './geoCoordinateDto';

export interface FieldGeometryDto {
  area?: number;
  boundNorthWest?: GeoCoordinateDto;
  boundSouthEast?: GeoCoordinateDto;
  boundary?: Array<BoundaryDto>;
  centroid?: GeoCoordinateDto;
  comment?: string;
  deleted?: boolean;
  fieldId?: number;
  id?: number;
  name?: string;
  pois?: Array<POIDto>;
  updated?: string;
}
